import React, { useState } from "react";
import "../UIcss/Button.css";
import Pagination from "./Pagination.jsx";
import CodeViewer from "./CodeViewer.jsx";
import { buttonData } from "./buttonData.js";
import { LuCopy, LuInfo,LuMousePointer2  } from "react-icons/lu";

// --- HELPER TO GET CODE ---
const getGeneratedCode = (btn) => {
  const htmlCode = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${btn.name} - CodePulse UI</title>
    <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&family=Outfit:wght@400;600;700&display=swap" rel="stylesheet">
    <style>
        body { 
            display: flex; 
            justify-content: center; 
            align-items: center; 
            margin: 0; 
            font-family: 'Inter', sans-serif;
        }
        
        /* Button Styles */
        ${btn.css}
    </style>
</head>
<body>
    ${btn.html}
</body>
</html>`;

  return { html: htmlCode, css: btn.css };
};

const ButtonRenderer = ({ btn, onOpenViewer }) => {
  const { html, css } = getGeneratedCode(btn);

  return (
    <div className="button-card">
      <div className="button-card-header">
        <div className="button-label">{btn.name}</div>
        <button 
          className="button-copy-btn"
          onClick={(e) => {
            e.stopPropagation();
            onOpenViewer(btn.name, html, css);
          }}
        >
          <LuCopy />
        </button>
      </div>

      <div className="button-preview-area">
        <div dangerouslySetInnerHTML={{ __html: btn.html }} />
      </div>

      <div className="button-meta-info">
        <LuInfo size={14} />
        <span>{btn.label}</span>
      </div>
    </div>
  );
};

const Button = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 40;
  const totalItems = buttonData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const [viewerState, setViewerState] = useState({
    isOpen: false,
    name: "",
    jsx: "",
    css: "",
  });

  const openViewer = (name, jsx, css) => {
    setViewerState({ isOpen: true, name, jsx, css });
  };

  const closeViewer = () => {
    setViewerState({ ...viewerState, isOpen: false });
  };

  const currentItems = buttonData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="button-library-wrapper">
      <div className="library-header">
        <div className="header-content">
          <h1><LuMousePointer2 /> Buttons <span>Library</span></h1>
        </div>
      </div>



      <div className="button-grid-container">
        {currentItems.map((btn) => (
          <ButtonRenderer 
            key={btn.id} 
            btn={btn} 
            onOpenViewer={openViewer} 
          />
        ))}
      </div>

      <div className="pagination-spacer">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
        />
      </div>

      <CodeViewer
        isOpen={viewerState.isOpen}
        onClose={closeViewer}
        componentName={viewerState.name}
        jsxCode={viewerState.jsx}
        cssCode={viewerState.css}
      />
    </div>
  );
};

export default Button;

